import { type Middleware } from 'swr'
import { useContextMyAccountDialog } from '../components/cosign/myAccount/Provider/useContextMyAccountDialog'

export const withCosignTooManyRequests: Middleware = (useSWRNext) => {
  return (key, fetcher, config) => {
    const { showDialogServerError } = useContextMyAccountDialog()
    const swr = useSWRNext(key, fetcher, {
      ...config,
      onError: (error, ...rest) => {
        const errorCode = error?.response?.data?.code
        if (errorCode === 429100 || errorCode === 429101) {
          showDialogServerError()
        }
        // FIXME: Need better error type for Middleware

        config?.onError?.(error, ...rest)
      },
    })
    return swr
  }
}
